/**
 * Web implementation of the cross-platform `numberOfLines` text prop.
 *
 * Native maps `numberOfLines` straight onto `RNText`. A web `<span>` has no
 * equivalent, so emit the CSS that produces the same result.
 *
 * Two details matter for the single-line case:
 * - `text-overflow` only takes effect on a block container, so the inline
 *   `<span>` is promoted to `display: block` and capped at `max-width: 100%`.
 * - `min-width: 0` lets the text shrink below its own content width when it
 *   sits in a flex row. Without it a `nowrap` label keeps its full intrinsic
 *   width and pushes its siblings (icons, chevrons) out of a fixed-width field.
 *
 * Returns an empty string when there is nothing to clamp, so the declaration
 * block stays untouched for the majority of callers.
 */
export const truncationStyles = (numberOfLines?: number): string => {
  if (!numberOfLines || numberOfLines < 1) return "";

  if (numberOfLines === 1) {
    return `
      display: block;
      max-width: 100%;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    `;
  }

  return `
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: ${numberOfLines};
    line-clamp: ${numberOfLines};
    max-width: 100%;
    min-width: 0;
    overflow: hidden;
  `;
};
